import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";

import { Address, IAddress } from "./../../shared/models/address";
import { IRenewal, Renewal } from "./../../shared/models/products/renewal";

import { NotificationsService } from "./../../../shared/services/notifications.service";
import { UserService } from "./../../../shared/services/user.service";
import { ViewStateService } from "./../../../shared/services/view-state.service";
import { PurchaseService } from "./../../shared/services/purchase.service";
import { PurchaseStateService } from "./../../shared/services/purchase-state.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-annual-renewal",
  templateUrl: "./annual-renewal.component.html",
})
export class AnnualRenewalComponent implements OnInit, OnDestroy {
  renewalForm: FormGroup;
  product: IRenewal;
  isIneligible: boolean;
  isRenewalPending: boolean;
  renewalType: string;
  renewalInfo: any[];
  isSubjectToCMP: boolean;
  renewalYearCharity: any[];
  charities: any[];
  renewalsPicked: IRenewal[];
  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private notifications: NotificationsService,
    private purchaseService: PurchaseService,
    private purchaseState: PurchaseStateService,
    private viewState: ViewStateService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.viewState.startLoading();
    this.buildForm();
    //this.purchaseState.reset();
    this.getRenewalInfo();
    this.renewalYearCharity = [];
  }

  onSubmit(updatedFormValue) {
    // if (!updatedFormValue.renewalType) {
    //   this.notifications.error('Type Required', 'Please select an option.');
    //   return;
    // }
    // if (updatedFormValue.renewalType === 'qualified') {
    //   this.renewalType = 'A'
    // } else {
    //   this.renewalType = 'S'
    // }
    if (!this.validateForm()) return;

    this.buildProductList();
    //    this.updatePurchaseState(updatedFormValue.renewalType);

    //    if (updatedFormValue.renewalType === "qualified")
    //      this.router.navigate(['purchase/annual-renewal/medical-director']);
    //    else
    this.router.navigate(["purchase/checkout"]);
  }

  askCharities(renewalYear: number): boolean {
    return renewalYear > 2019;
  }

  private buildForm() {
    this.renewalForm = this.formBuilder.group({
      renewalType: [null],
    });
  }

  private validateForm() {
    if (!this.renewalsPicked || this.renewalsPicked.length == 0) {
      this.notifications.error("Selection Required", "Please select a year.");
      return false;
    }
    if (this.renewalsPicked) {
      for (var i in this.renewalsPicked) {
        let renYear: number = Number(this.renewalsPicked[i].renewalYear);
        if (
          renYear > 2019 &&
          renYear < 2023 &&
          !this.renewalsPicked[i].annualFeeCharityId
        ) {
          this.notifications.error(
            "Selection Required",
            "Please select an organization."
          );
          return false;
        }
      }
    }
    return true;
  }

  enableCharity(renewalYear) {
    if (this.renewalsPicked)
      return this.renewalsPicked.find((p) => p.renewalYear == renewalYear);
    else return false;
  }

  pickCharity(renewalYear, charity) {
    let idx: number = this.renewalsPicked.findIndex(
      (p) => p.renewalYear == renewalYear
    );
    this.renewalsPicked[idx].annualFeeCharityId = charity.id;
  }

  defaultNotParticipate(renewalYear) {
    let charityNdx = this.renewalYearCharity
      .find((p) => p.renewalYear == renewalYear)
      .charities.find((c) => c.description == "I choose not to participate").id;
    let idx: number = this.renewalsPicked.findIndex(
      (p) => p.renewalYear == renewalYear
    );
    this.renewalsPicked[idx].annualFeeCharityId = charityNdx;
  }

  chooseToParticipate(renewalYear, checked) {
    if (checked) {
      let charityNdx = this.renewalYearCharity
        .find((p) => p.renewalYear == renewalYear)
        .charities.find((c) => c.description == "I choose to give.").id;
      let idx: number = this.renewalsPicked.findIndex(
        (p) => p.renewalYear == renewalYear
      );
      this.renewalsPicked[idx].annualFeeCharityId = charityNdx;
    } else {
      this.defaultNotParticipate(renewalYear);
    }
  }

  getRenewalYearCharity(renewalYear) {
    if (this.renewalYearCharity)
      return this.renewalYearCharity.find((p) => p.renewalYear == renewalYear)
        .charities;
    else return null;
  }

  pickRenewal(renewal, checked) {
    let ren: IRenewal;
    ren = new Renewal();
    ren.renewalYear = renewal.renewalYear;
    ren.quantity = 1;
    ren.serviceCodeId = renewal.activeID;
    ren.price = renewal.cost;
    ren.status = "A"; //the API will pick the right one

    if (!this.renewalsPicked && checked) {
      this.renewalsPicked = [];
      this.renewalsPicked.push(ren);
      if (parseInt(ren.renewalYear) > 2021 && parseInt(ren.renewalYear) < 2023)
        this.defaultNotParticipate(ren.renewalYear);
    } else if (
      checked &&
      !this.renewalsPicked.find((p) => p.renewalYear == renewal.renewalYear)
    ) {
      ren.renewalYear = renewal.renewalYear;
      this.renewalsPicked.push(ren);
      if (parseInt(ren.renewalYear) > 2021 && parseInt(ren.renewalYear) < 2023)
        this.defaultNotParticipate(ren.renewalYear);
    } else if (this.renewalsPicked && !checked) {
      this.renewalsPicked.splice(
        this.renewalsPicked.findIndex(
          (p) => p.renewalYear == renewal.renewalYear
        )
      );
    } else {
      //again not sure how we got here no renewals picked and unchecking
    }
  }

  private getCharities(renewalYear) {
    this.purchaseService
      .getCharities(renewalYear)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.charities = res;
        var ren = { renewalYear: renewalYear, charities: this.charities };
        this.renewalYearCharity.push(ren);
      });
  }

  private getRenewalInfo() {
    this.purchaseService
      .getRenewalInfo(this.userService.CurrentUser.personId)
      .subscribe(
        (res) => {
          this.renewalInfo = res;
          this.processRenewalInfo(res);
          this.updateUserStatus(res);
          this.isSubjectToCMP = this.userService.CurrentUser.subjectToCMP;
          this.viewState.stopLoading();
        },
        (error) => {
          this.viewState.stopLoading();
          // handle error if needed
          console.error("Error fetching renewal info:", error);
        }
      );
  }

  private processRenewalInfo(renewalInfo: any) {
    if (renewalInfo) {
      renewalInfo.forEach((info: any) => {
        this.getCharities(info.renewalYear);
      });
    }
  }

  private updateUserStatus(res: any) {
    if (!res[0]) {
      this.isRenewalPending = !this.userService.isCurrentUserInactive;
      this.isIneligible = this.userService.isCurrentUserInactive;
    }
  }

  private buildProductList() {
    for (var i in this.renewalsPicked) {
      this.handleRenewalResponse(this.renewalsPicked[i]);
      this.purchaseState.patchProducts(this.product);
    }
  }

  private handleRenewalResponse(renewalInfo) {
    this.product = new Renewal();
    this.product.annualFeeCharityId = renewalInfo.annualFeeCharityId;
    this.product.renewalYear = renewalInfo.renewalYear;
    this.product.quantity = 1;
    this.product.title = "Annual Fee for ".concat(this.product.renewalYear);
    this.product.description = "Annual Fee for ".concat(
      this.product.renewalYear
    );
    this.product.price = renewalInfo.price;

    if (this.isSubjectToCMP) {
      this.product.code = renewalInfo.serviceCodeId;
      this.product.status = "A";
      if (this.product.renewalYear == "2019") {
        this.product.code = "F04";
      } else {
        this.product.code = "F06";
      }
      this.product.serviceCodeId = renewalInfo.serviceCodeId;
    } else {
      this.product.code = renewalInfo.serviceCodeId;
      this.product.status = "S";
      if (this.product.renewalYear == "2019") {
        this.product.code = "F05";
      } else {
        this.product.code = "F07";
      }

      this.product.serviceCodeId = renewalInfo.serviceCodeId;
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
